import React, { Component, Fragment } from 'react';
import { withTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import i18n from '../../../i18n';
import { route } from "../../../routes";
import {
  OPERATION_GROUP, OPERATION_SELECTED,
  STATUS_AWAITING_AMENDMENTS,
  STATUS_AWAITING_TRANSLATION,
  STATUS_PUBLISHED,
  STEP_MASSUPDATE_SELECT,
  STEP_MASSUPDATE_SUBMIT,
  STEP_MASSUPDATE_SUCCESS,
} from "../../../constants";
import {
  SelectElement,
  CheckboxElement,
  FormFooter,
  FormHeader,
  GelContentContainer,
  FormNext,
  FormBack,
  FormSubmit,
  HeroBlock,
  Notice,
  FormErrorSummary,
  Notices,
  TextareaElement,
  DateISO8601Element,
  Loading,
  Form
} from "cw-styleguide-react";
import * as PropTypes from "prop-types";
import withAssets from '../../../components/hoc/withAssets';
import qs from "qs";
import WysiwygElement from '../../../components/WysiwygElement';

function TextFieldElement(props) {
  return null;
}

TextFieldElement.propTypes = {
  label: PropTypes.any,
  onChange: PropTypes.func,
  id: PropTypes.string,
  value: PropTypes.any,
  onKeyPress: PropTypes.func,
  name: PropTypes.string,
  size: PropTypes.string,
  errors: PropTypes.any
};

class CoursesMassUpdateView extends Component {


  render() {
    const isWorkBasedLearningCourse = ['267040002', '267040003', '267040004'].includes(this.props.courseGroupType);

    if (!this.props.loaded) {
      return <GelContentContainer>
        <FormErrorSummary errors={this.props.formErrors} />
        <Loading text={this.props.t('local:view.courses.massUpdate.messages.loading')} />
      </GelContentContainer>
    }
    return (
      <Fragment>
        <Helmet>
          <title>{this.props.t('local:view.courses.massUpdate.' + this.props.operation + '.' + this.props.step + '.title')}</title>
        </Helmet>
        <BreadcrumbsItem to={route("courses") + '/' + route(this.props.operation, this.props.operation === OPERATION_GROUP ? {courseGroup: this.props.courseGroup} : {} ) + qs.stringify({courses:this.props.selectedCourses}, {
          addQueryPrefix: true
        })}>
          {this.props.t('view.courses.massUpdate.' + this.props.operation + '.breadcrumb')}
        </BreadcrumbsItem>
        <GelContentContainer>
          <h1>{this.props.t('local:view.courses.massUpdate.' + this.props.operation + '.' + this.props.step + '.title')}</h1>
        </GelContentContainer>

        <HeroBlock>
          <p>{this.props.t('local:view.courses.massUpdate.' + this.props.operation + '.' + this.props.step + '.description')}</p>
        </HeroBlock>
        <GelContentContainer>


          <FormErrorSummary errors={this.props.formErrors} />
          {/* Show and messages */}
          <Notices messages={this.props.messages} />
          {this.props.step === STEP_MASSUPDATE_SELECT &&
            <Fragment>

              {this.props.operation === OPERATION_SELECTED &&
                <Notice
                  type={'cta'}>{this.props.t('local:view.courses.massUpdate.' + this.props.operation + '.notice', { count: this.props.selectedCourses.length })}</Notice>
              }
              {this.props.operation === OPERATION_GROUP &&
                <Notice
                  type={'cta'}>{this.props.t('local:view.courses.massUpdate.' + this.props.operation + '.notice.' + (this.props.courseCount === "1" ? 'singular' : 'plural'), { count: this.props.courseCount, name: this.props.courseGroupName })}</Notice>
              }


              <Form>

                <FormHeader
                  title={this.props.t('local:view.courses.massUpdate.' + this.props.operation + '.' + this.props.step + '.formTitle')}
                  introduction={this.props.t('local:view.courses.massUpdate.' + this.props.operation + '.' + this.props.step + '.formDescription')}>

                </FormHeader>

                <CheckboxElement onChange={this.props.handleSelected} id={'content'} name={'content'}
                  checked={this.props.selected.has('content')} value={"content"}
                  label={this.props.t('local:view.courses.massUpdate.field.content.label')} />
                {!isWorkBasedLearningCourse && <CheckboxElement onChange={this.props.handleSelected} id={'summary'} name={'summary'}
                  checked={this.props.selected.has('summary')} value={"summary"}
                  label={this.props.t('local:view.courses.massUpdate.field.summary.label')} /> }
                {!isWorkBasedLearningCourse && <CheckboxElement onChange={this.props.handleSelected} id={'entry'} name={'entry'}
                  checked={this.props.selected.has('entry')} value={"entry"}
                  label={this.props.t('local:view.courses.massUpdate.field.entry.label')} /> }
                <CheckboxElement onChange={this.props.handleSelected} id={'enrolment'} name={'enrolment'}
                  checked={this.props.selected.has('enrolment')} value={"enrolment"}
                  label={this.props.t('local:view.courses.massUpdate.field.enrolment.label')} />
                <CheckboxElement onChange={this.props.handleSelected} id={'cost'} name={'cost'}
                  checked={this.props.selected.has('cost')} value={"cost"}
                  label={this.props.t('local:view.courses.massUpdate.field.cost.label')} />
                <CheckboxElement onChange={this.props.handleSelected} id={'reviewDate'} name={'reviewDate'}
                  checked={this.props.selected.has('reviewDate')} value={"reviewDate"}
                  label={this.props.t('local:view.courses.massUpdate.field.reviewDate.label')} />

                <FormFooter>
                  <FormNext disabled={!this.props.selected.size}
                    onClick={(e) => this.props.handleSetStep(e, STEP_MASSUPDATE_SUBMIT)} />
                </FormFooter>
              </Form>
            </Fragment>
          }
          {this.props.step === STEP_MASSUPDATE_SUBMIT &&

            <Fragment>


              <Form className={'form--multi-step'}>

                <FormHeader
                  title={this.props.t('local:view.courses.massUpdate.' + this.props.operation + '.' + this.props.step + '.formTitle')}
                  introduction={this.props.t('local:view.courses.massUpdate.' + this.props.operation + '.' + this.props.step + '.formDescription')}>

                </FormHeader>

                {/* content*/}
                {this.props.selected.has('content') &&

                  <WysiwygElement
                    name={'content'}
                    id={'content'}
                    label={this.props.t('local:view.courses.massUpdate.field.content.label')}
                    description={this.props.t('local:view.courses.massUpdate.field.content.description')}
                    value={this.props.values['content']}
                    errors={this.props.formErrors['content']}
                    onChange={(e) => this.props.handleSetFormValue('content', e.data.get())}
                    required={true}
                  />

                }
                {this.props.selected.has('summary') &&
                  <WysiwygElement
                    name={'summary'}
                    id={'summary'}
                    description={this.props.t('local:view.courses.massUpdate.field.summary.description')}
                    value={this.props.values['summary']}
                    label={this.props.t('local:view.courses.massUpdate.field.summary.label')}
                    errors={this.props.formErrors['summary']}
                    onChange={(e) => this.props.handleSetFormValue('summary', e.data.get())}
                    required={true}
                  />


                }
                {this.props.selected.has('entry') &&
                  <WysiwygElement
                    name={'entry'}
                    id={'entry'}
                    description={this.props.t('local:view.courses.massUpdate.field.entry.description')}
                    value={this.props.values['entry']}
                    label={this.props.t('local:view.courses.massUpdate.field.entry.label')}
                    errors={this.props.formErrors['entry']}
                    onChange={(e) => this.props.handleSetFormValue('entry', e.data.get())}
                    required={true}
                  />
                }

                {this.props.selected.has('enrolment') &&
                  <WysiwygElement
                    name={'enrolment'}
                    id={'enrolment'}
                    description={this.props.t('local:view.courses.massUpdate.field.enrolment.description')}
                    value={this.props.values['enrolment']}
                    label={this.props.t('local:view.courses.massUpdate.field.enrolment.label')}
                    errors={this.props.formErrors['enrolment']}
                    onChange={(e) => this.props.handleSetFormValue('enrolment', e.data.get())}
                  />
                }
                {this.props.selected.has('cost') &&

                  <TextareaElement size={'full-width'}
                    label={this.props.t('local:view.courses.massUpdate.field.cost.label')}
                    description={this.props.t('local:view.courses.massUpdate.field.cost.description')}
                    id={'cost'}
                    name={'cost'}
                    value={this.props.values['cost']}
                    onChange={this.props.handleChange}
                    errors={this.props.formErrors['cost']}
                    onKeyPress={this.context.preventDefaultOnEnter} />}

                <DateISO8601Element id={'reviewDate'}
                  name={'reviewDate'}
                  label={this.props.t('local:view.courses.massUpdate.field.reviewDate.label')}
                  description={this.props.t('local:view.courses.massUpdate.field.reviewDate.description')}
                  required={true}
                  value={this.props.values['reviewDate']}
                  errors={this.props.formErrors['reviewDate']}
                  onChange={this.props.handleChange} />

                <SelectElement
                  required={true}
                  size={'medium'}
                  id={'status'}
                  name={'status'}
                  label={this.props.t('local:view.courses.massUpdate.field.status.label')}
                  options={[
                    { value: '', label: this.props.t('styleguide:forms.pleaseSelect'), disabled: true },
                    { value: STATUS_PUBLISHED, label: this.props.courses.getStatusName(STATUS_PUBLISHED) },
                    { value: STATUS_AWAITING_AMENDMENTS, label: this.props.courses.getStatusName(STATUS_AWAITING_AMENDMENTS) },
                  ]}
                  value={this.props.values['status'] || ''}
                  errors={this.props.formErrors['status']}
                  onChange={this.props.handleChange}
                />

                <FormFooter>
                  <FormBack onClick={(e) => this.props.handleSetStep(e, STEP_MASSUPDATE_SELECT)} />
                  {this.props.operation === OPERATION_SELECTED && <FormSubmit title={'Submit'} value={'Submit'} icon={{ type: 'chevron-right', position: 'right' }}
                    onClick={this.props.handleSubmitSelected}
                    spinner={this.props.submitting ? 'spinner' : null}>
                    {this.props.t('styleguide:forms.submit')}
                  </FormSubmit>}
                  {this.props.operation === OPERATION_GROUP && <FormSubmit title={'Submit'} value={'Submit'} icon={{ type: 'chevron-right', position: 'right' }}
                    onClick={this.props.handleSubmitGroup}
                    spinner={this.props.submitting ? 'spinner' : null}>
                    {this.props.t('styleguide:forms.submit')}
                  </FormSubmit>}

                </FormFooter>
              </Form>
            </Fragment>
          }

          {this.props.step === STEP_MASSUPDATE_SUCCESS && <Fragment>


          </Fragment>}

          {this.props.operation === OPERATION_SELECTED &&
            <FormBack url={route('coursesManage') + this.props.query} title={this.props.t('local:view.courses.massUpdate.' + this.props.operation + '.backTitle')}>{this.props.t('local:view.courses.massUpdate.' + this.props.operation + '.back')}</FormBack>}

          {this.props.operation === OPERATION_GROUP &&
            <FormBack url={route('courseGroupsManage') + this.props.query}  title={this.props.t('local:view.courses.massUpdate.' + this.props.operation + '.backTitle')}>{this.props.t('local:view.courses.massUpdate.' + this.props.operation + '.back')}</FormBack>}

        </GelContentContainer>

      </Fragment>
    );
  }
}

export default withAssets(withTranslation('local')(CoursesMassUpdateView));
